import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance as axios } from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'hrVacation',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getVacationsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },
    getVacationSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },
    createVacationSuccess(state, action) {
      state.isLoading = false;
      state.data = [...state.data, action.payload];
      state.error = false;
    },
    updateVacationSuccess(state, action) {
      state.record = action.payload;
      state.isLoading = false;
      state.data = map(state.data, (_record) => (_record.id === action.payload.id ? action.payload : _record));
      state.params = { ...state.params };
      state.error = false;
    },
    deleteVacationSuccess(state, action) {
      state.isLoading = false;
      state.data = filter(state.data, (r) => r.id !== action.payload.id);
      state.error = false;
    },
    setParams(state, action) {
      state.params = action.payload;
    },
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

export default slice.reducer;
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getVacations(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/vacation/', { params });
      dispatch(slice.actions.getVacationsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function getVacation(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/hr/vacation/${id}/`);
      dispatch(slice.actions.getVacationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createVacation(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/hr/vacation/', record);
      dispatch(slice.actions.createVacationSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateVacation(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/hr/vacation/${id}/`, record);
      dispatch(slice.actions.updateVacationSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateVacation(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/hr/vacation/${id}/`, record);
      dispatch(slice.actions.updateVacationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteVacation(id, restore = false) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/hr/vacation/${id}/`, { data: { restore } });
      dispatch(slice.actions.deleteVacationSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionVacation(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/vacation/${id}/action/`, data);
      dispatch(slice.actions.updateVacationSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionHistoryVacation(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/vacation/${id}/history/`, data);
      dispatch(slice.actions.updateVacationSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
